import { Formik } from 'formik';
import React from 'react';

import { ValidationForgetPassword } from 'common/validations';
import PrimaryButton from 'components/form/buttons/primaryButton';
import TextIput from 'components/form/textInput';
import Gap from 'components/gap';
import { useActions } from 'common/hooks/useActions';
import { toast } from 'common/helpers/toastConfig';

// import * as S from "../../styles";

const ForgetasswordForm: React.FC = () => {
  const { forgetPasswordRequestAction } = useActions();

  return (
    <Formik
      initialValues={{ mail: '' }}
      validationSchema={ValidationForgetPassword}
      onSubmit={(values, { setSubmitting }) => {
        /*
         * The action only raises a toast when the request fails, and this
         * callback used to be empty — so a request that succeeded left the
         * screen exactly as it was and read as a dead button. The success
         * lives here rather than in the action because the action is the data
         * layer; the screen is what owes the user an answer.
         */
        forgetPasswordRequestAction(values, () => {
          toast({
            model: 'success',
            message: `If ${values.mail} belongs to an account, a reset link is on its way.`
          });
        });
        setSubmitting(false);
      }}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
        <>
          <Gap size="24px" />
          <TextIput
            label="Email"
            type="text"
            name="mail"
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Please enter your mail"
            value={values.mail}
            message={touched.mail && errors.mail}
            error={errors.mail as unknown as boolean}
          />
          <Gap size="24px" />

          <PrimaryButton onClick={handleSubmit} disabled={isSubmitting} style={{ width: '100%' }}>
            Reset Password
          </PrimaryButton>
        </>
      )}
    </Formik>
  );
};

export default ForgetasswordForm;
